import Banner1 from "./Banner1";

export default Banner1;
